const emptyRegex = /\s+/g;
const illegalRegex = /[\/\?<>\\:\*\|":|\(|\)]/g;
const controlRegex = /[\x00-\x1f\x80-\x9f]/g;
const reservedRegex = /^\.+$/;
const windowsReservedRegex = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
const windowsTrailingRegex = /[\. ]+$/;

export function sanitize(input: string, replacement = "_") {
  return input
    .replace(emptyRegex, replacement)
    .replace(illegalRegex, replacement)
    .replace(controlRegex, replacement)
    .replace(reservedRegex, replacement)
    .replace(windowsReservedRegex, replacement)
    .replace(windowsTrailingRegex, replacement);
}
